import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemBrightnessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-brightness-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemBrightnessOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemBrightness = useGetKeyFromEffectsActiveItem('brightness');

  if (!activeItem || (activeItem && !('effects' in activeItem)) || activeItemBrightness === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  const updateBrightness = (brightness: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          brightness,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemBrightnessOption brightness={activeItemBrightness} updateBrightness={updateBrightness} />;
}
